//general
export const SET_GENERAL_DATA = "SET_GENERAL_DATA";
export const TOGGLE_NAV_DRAWER = "TOGGLE_NAV_DRAWER";
export const SHOW_APP_BAR = "SHOW_APP_BAR";
export const IS_LOADING = "IS_LOADING";
export const SHOW_ALERT_DIALOG = "SHOW_ALERT_DIALOG";
export const SHOW_CONFIRM_DIALOG = "SHOW_CONFIRM_DIALOG";
export const SET_CONFIRM_DIALOG_DATA = "SET_CONFIRM_DIALOG_DATA";
export const SET_ALERT_DIALOG_CONTENT = "SET_ALERT_DIALOG_CONTENT";

//form
export const SET_FORM_DATA = "SET_FORM_DATA";

//form
export const SET_REGISTRATION_DATA = "SET_REGISTRATION_DATA";

//auth
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";

//get banks
export const SET_BANK_LIST = "SET_BANK_LIST";

//payment
export const SET_STUDENT_RECEIPTS_DATA = "SET_STUDENT_RECEIPTS_DATA";

export const SET_STUDENT_PAYMENT_DATA = "SET_STUDENT_PAYMENT_DATA";
export const SHOW_STUDENT_PAYMENT_DIALOG = "SHOW_STUDENT_PAYMENT_DIALOG";

export const SET_TEACHER_SALARY_DATA = "SET_TEACHER_SALARY_DATA";
export const SET_TEACHER_SALARY_DETAIL = "SET_TEACHER_SALARY_DETAIL";
export const SHOW_TEACHER_PAYMENT_DIALOG = "SHOW_TEACHER_PAYMENT_DIALOG";

export const SET_STUDENT_MISC_PAYMENT_DATA = "SET_STUDENT_MISC_PAYMENT_DATA";
export const SHOW_STUDENT_MISC_PAYMENT_DIALOG = "SHOW_STUDENT_MISC_PAYMENT_DIALOG";

export const SET_PAYMENT_HISTORY_DATA = "SET_PAYMENT_HISTORY_DATA";

export const SET_FINANCE_REPORT_STUDENTS_DATA = "SET_FINANCE_REPORT_STUDENTS_DATA";
export const SET_FINANCE_REPORT_MONTHLY_DATA = "SET_FINANCE_REPORT_MONTHLY_DATA";

export const GET_ANNOUNCEMENTS = "GET_ANNOUNCEMENTS";
export const CREATE_ANNOUNCEMENT = "CREATE_ANNOUNCEMENT";
export const UPDATE_ANNOUNCEMENT = "UPDATE_ANNOUNCEMENT";

export const GET_QUIZ = "GET_QUIZ";
export const CREATE_QUIZ = "CREATE_QUIZ";
export const UPDATE_QUIZ = "UPDATE_QUIZ";

export const GET_NOTE = "GET_NOTE";
export const CREATE_NOTE = "CREATE_NOTE";
export const UPDATE_NOTE = "UPDATE_NOTE";

export const GET_TIMETABLE = "GET_TIMETABLE";

//Set role
export const SET_ROLE = "SET_ROLE";


